import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//Actions
import * as marketsActions from '../../actions/marketsActions';
import * as ordersActions from '../../actions/ordersActions';

//Components
import MarketSection from './marketsSection';
import MarketLogPopup from './marketLogPopup';
import MarketlogFilter from './marketlogFilter';

import { toggleFullScreen, getContactEmailText, comparatorViewByOrder } from '../../services/utils';

class Markets extends React.Component {
    constructor(props) {
		super(props);

        this.renderCustomViewList = this.renderCustomViewList.bind(this);
	}

    renderCustomViewList() {
         let { views } = this.props.user.userInfo;
        if (views && views.length) {
            return (
                <div className='online-market-container'>
               
               <div className='online-market-title'>Grid trading views</div>
                    { views.filter(item => item.view_type && item.view_type === 'grid')
                    .sort(comparatorViewByOrder).map( item =>
                    <div
                    key={'customView'+item.id}
                    className='online-market-line custom-view-line'>
                        <div onClick={this.showProductInfo.bind(this, false, item.args, item)}>
                            { item.name }
                        </div>
                        {item.view_type != "grid"  ? 
                            <div className='delete' onClick={this.props.actions.deleteCustomView.bind(this, item.id)}>
                                delete
                            </div>
                        : null }
                    </div>
                    )}    
                <div className='online-market-title'>Customised trading views</div>
                  { views.filter(item => !item.view_type || item.view_type !== 'grid').map( item =>
                    <div
                        key={'customView'+item.id}
                        className='online-market-line custom-view-line'>
                        <div onClick={this.showProductInfo.bind(this, false, item.args, item)}>
                            { item.name }
                        </div>
                        <div className='delete' onClick={this.props.actions.deleteCustomView.bind(this, item.id)}>
                            delete
                        </div>
                    </div>
                  )}                
            
                </div>
            )
        }
    }

    showProductInfo(data, customArgs, view) {
        if (customArgs) {
            this.props.actions.storeMarketLogArgs(customArgs)
            this.props.actions.setSelectedView(view)
            localStorage.setItem('marketLogArgs', JSON.stringify(customArgs));
            this.props.actions.getMarketLog(customArgs); // initiates search on open OnlineMarkets view
        } else {
            this.props.actions.getMarketLog(this.getRequestArgs(data ? data.id : false));
            this.props.actions.setSelectedView(null)
        }
        this.props.actions.showOnlineMarketLog(view && view.view_type || 'list');
    }

    getRequestArgs(productId) {
        var optionsStatus = [{value:'OPEN', name:'LIVE', selected: true},{value:'CLOSED',name:'DONE', selected: false},{value:'EXPIRED',name:'EXPIRED', selected: true}];
        var optionsIntents = [{value:'SELL', name:'BUY NOW', selected: true},{value:'BUY',name:'SELL NOW', selected: true}];
        var sortOrder = "ascending";
        var sortBy = "update_time";
        var args = {};
        var allProducts = this.props.user.userInfo.products;
        var allProductsIds = [];

        allProducts.map( item => {
            allProductsIds.push(item.id);
        })

        args.include = {};
        args.include.products = [];

        if (productId) {
            args.include.products.push(productId);
        } else {
            args.include.products = allProductsIds;
        }

        args.include.status = [];
        optionsStatus.forEach(function(element) {
          if(element.selected)
            args.include.status.push(element.value);
        });
        args.include.intents = [];
        optionsIntents.forEach(function(element) {
          if(element.selected)
            args.include.intents.push(element.value);
        });
        args.include.contract_type = ['OTC', 'CME', 'Physical'];

        args.sort_order = sortOrder;
        args.sort_by = sortBy;

        this.props.actions.storeMarketLogArgs(args)
        localStorage.setItem('marketLogArgs', JSON.stringify(args));
        return args;
    }

    handlePlaceOrder(data) {
        this.props.actions.placeOrder(data);
    }

    callDH(data) {
        const info = {
          subject: 'Request:',
          body: getContactEmailText(data)
        }
        this.props.actions.callDH(info);
    }

    render() {
        const { user, markets, app } = this.props,
        marketsData = user.userInfo.markets,
        { showOnlineMarketLog, hideOnlineMarketLog } = this.props.actions;
        return (
            <div>
                <h1>Trading screen</h1>
                { user.isLoggedIn &&
                <div className='online-market-container'>
                    <div onClick={this.showProductInfo.bind(this)} className='online-market-all'>
                        {user.isSuperuser || user.isAdmin ? 'Show all markets' : 'Show all products'}
                    </div>
                </div> }
                { this.renderCustomViewList() }
                <hr />               
                { marketsData && marketsData.length ? marketsData.map( item =>
                    <MarketSection
                        key={`marketGroup_${item.id}`}
                        data={item}
                        showProductInfo={this.showProductInfo.bind(this)}
                        products={item.products} />
                ) : null }                                              

                <MarketLogPopup
                    hide={hideOnlineMarketLog}
                    fullscreen={toggleFullScreen.bind(this, document.body)}
                    placeOrder={this.handlePlaceOrder.bind(this)}
                    isVisible={markets.isOnlineMarketLogVisible}
                    callDH={this.callDH.bind(this)}
                    getMarketLog={this.props.actions.getMarketLog}
                    storeMarketLogArgs={this.props.actions.storeMarketLogArgs}
                    showOrderPopup={this.props.actions.showOrderPopup}
                    getOrder={this.props.actions.getOrder}
                    showStatusbar={this.props.actions.showStatusbar}
                    hideStatusbar={this.props.actions.hideStatusbar}
                    requestStatusbarData={this.props.actions.requestStatusbarData}
                    user={this.props.user}
                    statusbar={markets.statusbar}
                    args={markets.marketLogArgs}
                    selectedView={markets.marketLogSelectedView}
                    data={markets.marketLogData}
                    actions={this.props.actions}
                    freights={app.freights} 
                    marketOrderNotifikation={markets.marketOrderNotifikation}/>

                <MarketlogFilter
                    hidePopup={this.props.actions.hideMarketlogFilter}
                    args={markets.marketLogArgs}
                    params={markets.marketlogFilter.params}
                    refreshMarketlog={this.props.actions.getMarketLog}
                    visible={markets.marketlogFilter.visible} />

            </div>
        )
    }
}

export default connect(
    state => ({
        markets: state.markets,
        user: state.user,
        app: state.app,
    }),
    dispatch => ({
        actions: bindActionCreators({...marketsActions, ...ordersActions}, dispatch)
    })
)(Markets);



// WEBPACK FOOTER //
// ./source/screens/markets/index.js